import React from 'react';
import {
  faGasPump,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { STATUS_IN_PROGRESS } from '../../../../api/constant';
import { useActionsHandOut, useHandOut } from '../../../../context/inventory/HandOutFormProvider';
import { formatNumberCOP } from '../../../../utilities/app.utilities';


export const ItemsHandOut = (items) => {
  let items_lote = items;
  const state = useHandOut();
  const actions = useActionsHandOut();
  const {
    movement: {
      status_id,
    },
    items_consume: { items_consume },
    item_selected_lote: {item_name, item_measure_name, item_code}
  } = state;

  return (
    <div className={`col-md-12 col-lg-12 ${items.items.length>0 ? "" : "mt-4"}`}>
      {items.items.length>0 &&(
        <label className="control-label font1">
          {item_name} en {item_measure_name} -- {item_code}
        </label>
      )}
      
      <table className="col-md-6 col-lg-6 table table-default-app">
        <thead>
          <tr>
            <th scope="col">Lote</th>
            <th scope="col">Fecha vencimiento</th>
            <th scope="col">Und. Lote</th>
            <th scope="col">Cant. Inventario</th>
          </tr>
        </thead>
        <tbody>
        {
          items.items.map((item, i) => {
            const showIcon = items_consume.some(item_consume => item_consume.inventory_parent_lote === item.inventory_parent_lote);
            return (
              <tr className='td-hoverme cursor-pointer' key={i}>
                <td>{item.lote}</td>
                <td>{item.date_expired}</td>
                <td>{item.abreviature}</td>
                <td className='txt-right'>{formatNumberCOP(item.stock)}</td>
                {!showIcon & status_id === STATUS_IN_PROGRESS ? (
                  <th>
                      <FontAwesomeIcon
                      className="cursor-pointer font-color-blue"
                      title="Consumir lote"
                      icon={faGasPump}
                      onClick={() =>
                        actions.addOutToMovementOutManually(item)
                      }
                    />
                </th>
                )
              :
              (<></>)}
                
              </tr>
            );
          })
        }
      
        </tbody>
      </table>
    </div>

  )
}
